
import { Component, Inject } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AlertService } from '../../../../services/alert.service';
import { QuoteTemplate } from '../../../../models/quote-template.model';


@Component({
    selector: 'create-edit-quote-template-modal',
    template: require('./create-edit-quote-template-modal.component.html'),
    styles: [require('./create-edit-quote-template-modal.component.css')]
})
export class CreateEditQuoteTemplateModalComponent {
    currentQuoteTemplate: QuoteTemplate;
    isCreatNew: boolean;
    quoteTemplateTypes = [];
    constructor(private alertService: AlertService, private apiService: ApiService, public dialogRef: MatDialogRef<CreateEditQuoteTemplateModalComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
        this.isCreatNew = (data.currentQuoteTemplate.quoteTemplateId == undefined);
        this.currentQuoteTemplate = data.currentQuoteTemplate;

    }

    ok() {
        if (!this.isCreatNew) {
            
            this.apiService.updateQuoteTemplate(this.currentQuoteTemplate).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Update QuoteTemplate successfully");
                }
            });
        } else {
            this.apiService.createQuoteTemplate(this.currentQuoteTemplate).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Create QuoteTemplate successfully");
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/quote-settings/quote-templates/create-edit-quote-template-modal/create-edit-quote-template-modal.component.ts